import mitt from 'mitt';

type BusPayload = {
  name: string;
  verifyUuid: string;
  verifyType?: string; // 可选，默认为 '102'
  rid: string;
  backgroundUrl: string;
  centerUrl: string;
};
type Events = {
  'captcha:show': BusPayload;
  'polling:resume': void;
};

export const bus = mitt<Events>();
